const FILES = "abcdefgh";
const RANKS = "12345678";

export function orderedSquares(orientation = "w") {
  const files = orientation === "w" ? FILES : [...FILES].reverse().join("");
  const ranks = orientation === "w" ? "87654321" : RANKS;
  return [...ranks].flatMap((rank) =>
    [...files].map((file) => `${file}${rank}`),
  );
}

export function moveBoardSquare(square, direction, orientation = "w") {
  const order = orderedSquares(orientation);
  const index = order.indexOf(square);
  if (index < 0) {
    return order[0];
  }
  let row = Math.floor(index / 8);
  let column = index % 8;
  if (direction === "left") {
    column -= 1;
  }
  if (direction === "right") {
    column += 1;
  }
  if (direction === "up") {
    row -= 1;
  }
  if (direction === "down") {
    row += 1;
  }
  row = Math.max(0, Math.min(7, row));
  column = Math.max(0, Math.min(7, column));
  return order[row * 8 + column];
}

export function cycleBoardSquare(current, candidates, step, orientation = "w") {
  const available = new Set(candidates);
  const ordered = orderedSquares(orientation).filter((square) =>
    available.has(square),
  );
  if (!ordered.length) {
    return current;
  }
  const index = ordered.indexOf(current);
  if (index < 0) {
    return step < 0 ? ordered.at(-1) : ordered[0];
  }
  return ordered[(index + step + ordered.length) % ordered.length];
}

export function gamepadDirection(gamepad) {
  if (!gamepad) {
    return null;
  }
  if (gamepad.buttons?.[12]?.pressed) {
    return "up";
  }
  if (gamepad.buttons?.[13]?.pressed) {
    return "down";
  }
  if (gamepad.buttons?.[14]?.pressed) {
    return "left";
  }
  if (gamepad.buttons?.[15]?.pressed) {
    return "right";
  }
  const x = Number(gamepad.axes?.[0] ?? 0);
  const y = Number(gamepad.axes?.[1] ?? 0);
  if (Math.abs(x) > Math.abs(y) && Math.abs(x) >= 0.58) {
    return x < 0 ? "left" : "right";
  }
  if (Math.abs(y) >= 0.58) {
    return y < 0 ? "up" : "down";
  }
  return null;
}
